export default {
  meta: {
    title: '流程设计'
  }
};
